import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { BrTabItems } from 'views/BrTabs/BrTabs';
import { ProfilingSection } from 'views/BrTabs/components/ProfilingSections/ProfilingSection';
import { useRuntimeConfig } from 'config/useRuntimeConfig';
import { NavigationWizardSectionRenderParams } from 'views/BrTabs/types/navigationWizardMode';
import { ZfServicingRolesNavigationWrapperWC } from '@juliusbaer-gcrm/pcm-br-mgmt-components/ZfServicingRolesNavigationWrapperWC';

export function ServicingUsersSection({ selectedTab, navigateToTab }: NavigationWizardSectionRenderParams): ReactNode {
  const runtimeConfig = useRuntimeConfig();
  const { t } = useTranslation();
  const isActive = selectedTab === BrTabItems.BR_SERVICING;

  return ProfilingSection({
    tabId: BrTabItems.BR_SERVICING,
    title: t('navigationWizard.item.title.servicingUsers'),
    isActive,
    isProfilingRelevant: false,
    onSectionSelect: () => navigateToTab(BrTabItems.BR_SERVICING),
    children: (
      <ZfServicingRolesNavigationWrapperWC
        env={runtimeConfig.envInfo.envId}
        version="0.0.1"
        onSectionSelect={() => navigateToTab(BrTabItems.BR_SERVICING)}
        isActive={isActive}
      />
    ),
  });
}
